import { Logo } from "./Logo";
import { NAV_LINKS } from "../../data/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-card/40">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16">
        <div className="flex flex-col gap-12 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <Logo className="h-20" />
            <p className="mt-5 text-sm leading-relaxed text-muted-foreground">
              Interlocked Solutions is an official UK channel partner for FireFlink — the complete
              AI-powered, scriptless test automation ecosystem.
            </p>
          </div>

          <div className="flex gap-16">
            <div>
              <h4 className="font-mono-ui text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                Navigate
              </h4>
              <ul className="mt-5 space-y-3">
                {NAV_LINKS.map((l) => (
                  <li key={l.href}>
                    <a
                      href={l.href}
                      data-testid={`footer-link-${l.label.toLowerCase()}`}
                      className="text-sm text-foreground/80 transition-colors hover:text-primary"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
                <li>
                  <a
                    href="/login"
                    data-testid="footer-team-login"
                    className="text-sm text-foreground/80 transition-colors hover:text-primary"
                  >
                    Login
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-mono-ui text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                Contact
              </h4>
              <ul className="mt-5 space-y-3 text-sm text-foreground/80">
                <li>
                  <a
                    href="mailto:info@interlockedsolutions.co.uk"
                    className="transition-colors hover:text-primary"
                  >
                    info@interlockedsolutions.co.uk
                  </a>
                </li>
                <li>United Kingdom</li>
                <li>
                  <a
                    href="https://fireflink.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors hover:text-primary"
                  >
                    fireflink.com ↗
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-border pt-8 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Interlocked Solutions Ltd. All rights reserved.</span>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <a href="/privacy-policy" data-testid="footer-privacy" className="transition-colors hover:text-primary">
              Privacy Policy
            </a>
            <a href="/cookie-policy" data-testid="footer-cookie" className="transition-colors hover:text-primary">
              Cookie Policy
            </a>
            <button
              data-testid="footer-cookie-settings"
              onClick={() => window.dispatchEvent(new Event("open-cookie-preferences"))}
              className="transition-colors hover:text-primary"
            >
              Cookie settings
            </button>
            <span>FireFlink™ is a trademark of its respective owner. Official channel partner.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
